// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.delivery-shop__title[data-v-bad7bb5a] {
    margin-top: 20px;
}
.delivery-shop-info[data-v-bad7bb5a] {
    margin: 20px 0;
    font-weight: bold;
}
.delivery-shop__choose[data-v-bad7bb5a] {
    margin-top: 20px;
}
.delivery-shop-cities[data-v-bad7bb5a] {
    margin: 15px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
}
.delivery-shop-cities__city[data-v-bad7bb5a] {
    flex: 0 0 auto;
    padding-left: 15px;
    padding-right: 15px;
    line-height: 2em;
    border-radius: 1em;
    color: var(--color-granite);
    background-color: var(--color-periwinkle-crayola);
}
.delivery-shop-cities__city.active[data-v-bad7bb5a] {
    color: var(--color-periwinkle-crayola);
    background-color: var(--color-granite);
}
.delivery-shop__map[data-v-bad7bb5a] {
    display: block;
    aspect-ratio: 16 / 9;
}
.delivery-shop__title[data-v-bad7bb5a] {
    margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./resources/assets/site/vue/shop.vue"],"names":[],"mappings":";AA6MA;IACI,gBAAgB;AACpB;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,iDAAiD;AACrD;AAEA;IACI,sCAAsC;IACtC,sCAAsC;AAC1C;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["\n.delivery-shop__title {\n    margin-top: 20px;\n}\n\n.delivery-shop-info {\n    margin: 20px 0;\n    font-weight: bold;\n}\n\n.delivery-shop__choose {\n    margin-top: 20px;\n}\n\n.delivery-shop-cities {\n    margin: 15px 0;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 5px;\n}\n\n.delivery-shop-cities__city {\n    flex: 0 0 auto;\n    padding-left: 15px;\n    padding-right: 15px;\n    line-height: 2em;\n    border-radius: 1em;\n    color: var(--color-granite);\n    background-color: var(--color-periwinkle-crayola);\n}\n\n.delivery-shop-cities__city.active {\n    color: var(--color-periwinkle-crayola);\n    background-color: var(--color-granite);\n}\n\n.delivery-shop__map {\n    display: block;\n    aspect-ratio: 16 / 9;\n}\n\n.delivery-shop__title {\n    margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
